import { useState, useEffect } from "react";
import { useAuth } from "@/App";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { API } from "./_apiConfig";

const NewsletterManagement = () => {
  const { token } = useAuth();
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    try {
      const response = await fetch(`${API}/admin/newsletter`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setSubscribers(data);
      }
    } catch (error) {
      console.error("Error fetching subscribers:", error);
    } finally {
      setLoading(false);
    }
  };

  const activeCount = subscribers.filter(s => s.active).length;
  const inactiveCount = subscribers.length - activeCount;

  return (
    <div data-testid="admin-newsletter">
      <h2 className="font-heading text-xl sm:text-2xl font-bold text-foreground mb-4 sm:mb-6">
        Abonnés Newsletter
      </h2>

      <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-4 sm:mb-6">
        <Card>
          <CardContent className="p-3 sm:pt-6 sm:px-6 text-center">
            <p className="text-xl sm:text-3xl font-bold text-foreground">{subscribers.length}</p>
            <p className="text-xs sm:text-sm text-muted-foreground">Total</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-3 sm:pt-6 sm:px-6 text-center">
            <p className="text-xl sm:text-3xl font-bold text-green-500">{activeCount}</p>
            <p className="text-xs sm:text-sm text-muted-foreground">Actifs</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-3 sm:pt-6 sm:px-6 text-center">
            <p className="text-xl sm:text-3xl font-bold text-muted-foreground">{inactiveCount}</p>
            <p className="text-xs sm:text-sm text-muted-foreground">Désinscrits</p>
          </CardContent>
        </Card>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
        </div>
      ) : subscribers.length > 0 ? (
        <div className="rounded-xl border border-border overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="min-w-[150px]">Email</TableHead>
                <TableHead className="min-w-[100px]">Nom</TableHead>
                <TableHead>Statut</TableHead>
                <TableHead className="min-w-[100px]">Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subscribers.map((sub) => (
                <TableRow key={sub.id}>
                  <TableCell className="font-medium text-sm">{sub.email}</TableCell>
                  <TableCell className="text-sm">{sub.name || "-"}</TableCell>
                  <TableCell>
                    {sub.active ? (
                      <Badge variant="outline" className="text-green-500 border-green-500 text-xs">
                        Actif
                      </Badge>
                    ) : (
                      <Badge variant="outline" className="text-muted-foreground text-xs">
                        Désinscrit
                      </Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {new Date(sub.created_at).toLocaleDateString("fr-FR")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <Card>
          <CardContent className="py-8 text-center text-muted-foreground">
            Aucun abonné pour le moment.
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default NewsletterManagement;
